import {businessCalendarDate} from 'src/api/business-time'

import {parseApiDate} from '../jobs/job-schedule-format'
import type {TerminalRowEntry} from './terminal-jobs'
import type {DispatchJobSchedule} from './types'

export function endedBeforeYesterday(
    schedule: Pick<DispatchJobSchedule, 'endDate'> | undefined,
    today = businessCalendarDate(),
): boolean {
    const endDate = schedule?.endDate
    if (!endDate) {
        return false
    }

    const yesterday = new Date(today)
    yesterday.setDate(yesterday.getDate() - 1)
    return parseApiDate(endDate) < yesterday
}

function isCleanUpEntry(entry: TerminalRowEntry, today = businessCalendarDate()): boolean {
    return endedBeforeYesterday(entry.job.schedule, today)
}

export function splitCleanUp(
    entries: TerminalRowEntry[],
    today = businessCalendarDate(),
): {current: TerminalRowEntry[]; cleanUp: TerminalRowEntry[]} {
    const current: TerminalRowEntry[] = []
    const cleanUpByJob = new Map<string, TerminalRowEntry>()
    for (const entry of entries) {
        if (isCleanUpEntry(entry, today)) {
            if (!cleanUpByJob.has(entry.job.id)) cleanUpByJob.set(entry.job.id, entry)
        } else {
            current.push(entry)
        }
    }
    const cleanUp = [...cleanUpByJob.values()].sort((a, b) =>
        (a.job.schedule?.endDate ?? '').localeCompare(b.job.schedule?.endDate ?? ''),
    )
    return {current, cleanUp}
}
